module.exports = __webpack_public_path__ + "img/Vue_Logo_45x53.cdaca857.png";